/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
	// 设置永久缓存
	set(key, val) {
		window.localStorage.setItem(key, JSON.stringify(val));
	},
	// 获取永久缓存
	get(key) {
		let json = window.localStorage.getItem(key);
		return JSON.parse(json);
	},
	// 移除永久缓存
	remove(key) {
		window.localStorage.removeItem(key);
	},
	// 移除全部永久缓存
	clear() {
		window.localStorage.clear();
	},
};

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
	// 设置临时缓存
	set(key, val) {
		window.sessionStorage.setItem(key, JSON.stringify(val));
	},
	// 获取临时缓存
	get(key) {
		let json = window.sessionStorage.getItem(key);
		return JSON.parse(json);
	},
	// 移除临时缓存
	remove(key) {
		window.sessionStorage.removeItem(key);
	},
	// 移除全部临时缓存
	clear() {
		window.sessionStorage.clear();
	},
};



// indexDB,将群聊的群组信息加入到浏览器的数据库中
import localforage from "localforage";
/**
 * 关于indexdb的缓存设置
 * @method set 设置缓存
 * @method get 获取缓存
 * @method clear 删除所有的key，并且重置数据库。
 * @method removeItem 删除key对应的值
 *
 * @param key  键
 * @param val  值
 */
export const IndexDB = {
  // 设置缓存
  set(key, val) {
    localforage.setItem(key, JSON.stringify(val));
  },
  // 获取缓存
  async get(key) {
    let data = await localforage.getItem(key);
    return JSON.parse(data);
  },
  //   删除key对应的值
  removeItem(key) {
    localforage.removeItem(key);
  },
  // 清除全部缓存
  clear() {
    localforage.clear();
  },
};



// 今日是否弹出
export function isTodayPop() {
	const today = new Date();
	const todayStr = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
	const todayStr2= `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
	if (Local.get('popToday') === todayStr) {
		return true;
	} else {
				Local.set('popToday', todayStr);
		return false;
	}

}